import React from "react";

export default function EnvTool({ payload, result }) {
  const name = payload?.name || "";
  const input = payload?.input || {};
  const path = input.path || "";
  const isWrite = name === "env_write_file";
  return (
    <div className="tool-card-body">
      <div className="tool-section">
        <h5>{name.replace("env_", "").replace("_", " ")}</h5>
        {path && <pre className="tool-pre">{path}</pre>}
      </div>
      {isWrite && input.content !== undefined && (
        <div className="tool-section">
          <h5>Content written</h5>
          <pre className="tool-pre">{input.content}</pre>
        </div>
      )}
      {result && (
        <div className="tool-section">
          <h5>Result {result.is_error ? "(error)" : ""}</h5>
          <pre className="tool-pre">{result.content_preview || ""}</pre>
          {result.has_more && <div className="tool-truncated">…truncated.</div>}
        </div>
      )}
    </div>
  );
}
EnvTool.summarize = (p) => {
  const name = p?.name || "";
  const path = p?.input?.path || "";
  if (name === "env_list_files") return "(no args)";
  return path;
};
